import {user, request, storage} from 'lib'


import find from 'lodash/find';
import assign from 'lodash/assign';
import forEach from "lodash/forEach";
import map from "lodash/map";
import uniqBy from "lodash/uniqBy";




// import {getStore} from '../store'


let medalList = []
let CACHE_KEY = 'MEDAL_LIST'

let enterList = {}

const init = async () => {
  let res = await request.api.get('show/medals_list');

  medalList = res.all_medals || [];
storage.setItem(CACHE_KEY,medalList)

}

const getMedalList = () => {
  return medalList;
}

const getMedal = (_id) => {
  if(medalList.length===0){
    medalList = storage.getItem(CACHE_KEY)
  }
  return find(medalList, {_id});
}


export default {
  init,
  getMedal,
  getMedalList
}

